import React, { FC, PropsWithChildren, useCallback, useEffect, useState } from 'react'
import { getCardEditUrl, updatePaymentType } from '~/api/PaymentRepository'
import { usePartialAuth } from '~/contexts/AuthContext'
import { PaymentMethodKind } from '~/lib/types/AdvAccount'
import { SimpleDialog } from './SimpleDialog'
import { Typography } from '@mui/material'
import { snackActions } from '~/lib/snackbarHelper'
import { logger } from '~/lib/logger'
import { proxyLogin } from '~/lib/proxyLogin'

export const GmoSwitchChecker: FC<PropsWithChildren> = ({ children }) => {
  const { currentAdv } = usePartialAuth()
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  useEffect(() => {
    const fn = async () => {
      // 代理ログインの場合は以下の処理をスキップ
      if (proxyLogin.isProxyLogin()) {
        return
      }

      // payemntTypeがPAY.JP"以外"の場合は以下の処理をスキップ
      if (!currentAdv || currentAdv.paymentType !== PaymentMethodKind.CreditCard) {
        return
      }

      // GMO経由でカードが未登録なのでダイアログを表示
      if (!currentAdv.isRetrieveGmopgCustomer) {
        setIsDialogOpen(true)
        return
      }

      // GMO経由でカード登録済みだがpaymentTypeが未更新なので更新APIを叩く
      try {
        const result = await updatePaymentType()
        if (result.paymentType === PaymentMethodKind.CreditCardGmopg) {
          // 更新に成功したのでリロードする
          window.location.reload()
        } else {
          // 通常起きない(予期しないシステムエラー等)想定だが、無限ループを避けるためにリロードはしない
          logger.error(new Error(`Failed to update payment type (return payment type is ${result.paymentType})`))
        }
      } catch (e) {
        // 通常起きない(予期しないシステムエラー等)想定だが、無限ループを避けるためにリロードはしない
        logger.error(new Error('Failed to update payment type', { cause: e }))
      }
    }

    fn()
  }, [currentAdv])

  const handleAddCard = useCallback(() => {
    getCardEditUrl()
      .then(({ url }) => {
        window.location.href = url
      })
      .catch((e) => {
        snackActions.error('カードの再登録に失敗しました')
        logger.error(new Error('Failed to get card edit url', { cause: e }))
      })
  }, [])

  return (
    <>
      {children}
      <SimpleDialog
        open={isDialogOpen}
        title="クレジットカード情報の再登録のお願い"
        okButtonText="再登録する"
        onOk={handleAddCard}
        zIndex={10000}
      >
        <Typography>
          サービス向上のため決済システムを変更いたしました。お手数ですが、クレジットカード情報の再登録をお願いいたします。
        </Typography>
      </SimpleDialog>
    </>
  )
}
